import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeSpan'
})
export class TimeSpanPipe implements PipeTransform {

  transform(value: string): string {
    if (!value) return '00:00:00';
    
    // Osečemo milisekunde, uzimamo samo HH:mm:ss
    const parts = value.split('.')[0]; 
    return parts;
  }

  }


